import { Injectable } from '@angular/core';
import { RcsMessageDto } from './rcs-message-dto';

@Injectable({
  providedIn: 'root'
})

export class RcsMessageDtoAdapter {

  adapt(item: any): RcsMessageDto {
    return new RcsMessageDto(item);
  }
}